import { action, createRequestTypes } from './base';

export const invoiceActionTypes = {
  GET_INVOICE: createRequestTypes('GET_INVOICE'),
  GET_INVOICE_BY_ID: createRequestTypes('GET_INVOICE_BY_ID'),
  CREATE_INVOICE: createRequestTypes('CREATE_INVOICE'),
  UPDATE_INVOICE: createRequestTypes('UPDATE_INVOICE'),
  UPDATE_STATUS_INVOICE: createRequestTypes('UPDATE_STATUS_INVOICE'),
  UPDATE_INVOICE_WORKFLOW_STEP: createRequestTypes('UPDATE_INVOICE_WORKFLOW_STEP'),
  DELETE_INVOICE: createRequestTypes('DELETE_INVOICE'),
  INVOICE_LINK_PAYMENT: createRequestTypes('INVOICE_LINK_PAYMENT'),
  INVOICE_UNLINK_PAYMENT: createRequestTypes('INVOICE_UNLINK_PAYMENT'),
  DOWNLOAD_INVOICE: createRequestTypes('DOWNLOAD_INVOICE'),
  DOWNLOAD_SHIPPING_LABELS: createRequestTypes('DOWNLOAD_SHIPPING_LABELS'),
  DOWNLOAD_INVOICE_LIST: createRequestTypes('DOWNLOAD_INVOICE_LIST'),
  CREATE_BULK_RETURNS: createRequestTypes('CREATE_BULK_RETURNS'),
  QUICK_UPDATE_INVOICE: createRequestTypes('QUICK_UPDATE_INVOICE'),
  ISSUE_STOCK_FOR_INVOICE: createRequestTypes('ISSUE_STOCK_FOR_INVOICE'),
  REVERT_STOCK_FOR_INVOICE: createRequestTypes('REVERT_STOCK_FOR_INVOICE'),

};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param invoiceId
 * @param invoiceEntityId
 * @param invoiceEntityType
 * @param status
 * @param limit
 * @param page
 * @param tenantSellerId
 * @param selectedEntityType
 * @param callback
 */
class InvoiceActions {
  /**
   * @param {*} orgId
   * @param {*} invoiceId
   * @param {*} page
   * @param tenantId
   * @param customerId
   * @param searchKeyword
   * @param {*} limit
   * @return
   */
  getInvoice = (orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, callback, isMarketplaceInvoice, accountManagerIds, source, stockStatus, excludeInvoiceIds, excludeGRNCustomerIds, invoiceType) => action(invoiceActionTypes.GET_INVOICE.REQUEST, {
    orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, callback, isMarketplaceInvoice, accountManagerIds, source, stockStatus, excludeInvoiceIds, excludeGRNCustomerIds, invoiceType,
  })

  /**
   *
   * @param {*} getInvoiceLoading
   * @return
   */
  getInvoiceLoading = (getInvoiceLoading) => action(invoiceActionTypes.GET_INVOICE.LOADING, {
    getInvoiceLoading,
  })

  /**
   * @return
   * @param invoices
   * @param customFields
   */
  getInvoiceSuccess = (invoices) => action(invoiceActionTypes.GET_INVOICE.SUCCESS, {
    invoices,
  })

  /**
   * @param {*} tenantId
   * @param orgId
   * @param {*} invoiceId
   * @return
   */
  getInvoiceById = (orgId, tenantId, invoiceId, callback) => action(invoiceActionTypes.GET_INVOICE_BY_ID.REQUEST, {
    orgId, tenantId, invoiceId, callback
  })

  /**
   *
   * @param {*} getInvoiceByIdLoading
   * @return
   */
  getInvoiceByIdLoading = (getInvoiceByIdLoading) => action(invoiceActionTypes.GET_INVOICE_BY_ID.LOADING, {
    getInvoiceByIdLoading,
  })

  /**
   * @return
   * @param selectedInvoice
   * @param invoiceData
   */
  getInvoiceByIdSuccess = (selectedInvoice) => action(invoiceActionTypes.GET_INVOICE_BY_ID.SUCCESS, {
    selectedInvoice,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  createInvoice = (payload, callback) => action(invoiceActionTypes.CREATE_INVOICE.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param {*} createInvoiceLoading
   * @return
   */
  createInvoiceLoading = (createInvoiceLoading) => action(invoiceActionTypes.CREATE_INVOICE.LOADING, {
    createInvoiceLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateInvoice = (payload, callback) => action(invoiceActionTypes.UPDATE_INVOICE.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param {*} updateInvoiceLoading
   * @return
   */
  updateInvoiceLoading = (updateInvoiceLoading) => action(invoiceActionTypes.UPDATE_INVOICE.LOADING, {
    updateInvoiceLoading,
  })

  /**
   * @param tenantId
   * @param invoiceId
   * @param orgId
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateInvoiceStatus = (payload, callback) => action(invoiceActionTypes.UPDATE_STATUS_INVOICE.REQUEST, {
    payload, callback,
  })

  /**
   * @param updateInvoiceStatusLoading
   * @param deleteInvoiceLoading
   * @return {{type: *}}
   */
  updateInvoiceStatusLoading = (updateInvoiceStatusLoading) => action(invoiceActionTypes.UPDATE_STATUS_INVOICE.LOADING, {
    updateInvoiceStatusLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  deleteInvoice = (payload, callback) => action(invoiceActionTypes.DELETE_INVOICE.REQUEST, {
    payload, callback,
  })

  /**
   * @param deleteInvoiceLoading
   * @return {{type: *}}
   */
  deleteInvoiceLoading = (deleteInvoiceLoading) => action(invoiceActionTypes.DELETE_INVOICE.LOADING, {
    deleteInvoiceLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  linkIncomingPayment = (payload, callback) => action(invoiceActionTypes.INVOICE_LINK_PAYMENT.REQUEST, {
    payload, callback,
  })

  /**
   * @param linkIncomingPaymentsLoading
   * @return {{type: *}}
   */
  linkIncomingPaymentsLoading = (linkIncomingPaymentsLoading) => action(invoiceActionTypes.INVOICE_LINK_PAYMENT.LOADING, {
    linkIncomingPaymentsLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  unlinkIncomingPayment = (invoicePaymentId, callback) => action(invoiceActionTypes.INVOICE_UNLINK_PAYMENT.REQUEST, {
    invoicePaymentId, callback,
  })

  /**
   * @paramunlinkIncomingPaymentLoading
   * @return {{type: *}}
   */
  unlinkIncomingPaymentLoading = (unlinkIncomingPaymentLoading) => action(invoiceActionTypes.INVOICE_UNLINK_PAYMENT.LOADING, {
    unlinkIncomingPaymentLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateInvoiceWorkflowStep = (payload, callback) => action(invoiceActionTypes.UPDATE_INVOICE_WORKFLOW_STEP.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} updateInvoiceWorkflowStepLoading
   * @return
   */
  updateInvoiceWorkflowStepLoading = (updateInvoiceWorkflowStepLoading) => action(invoiceActionTypes.UPDATE_INVOICE_WORKFLOW_STEP.LOADING, {
    updateInvoiceWorkflowStepLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  downloadInvoice = (payload, callback) => action(invoiceActionTypes.DOWNLOAD_INVOICE.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @type {{type: *}}
   */
  downloadInvoiceLoading = (downloadInvoiceLoading) => action(invoiceActionTypes.DOWNLOAD_INVOICE.LOADING, {
    downloadInvoiceLoading,
  });

  downloadShippingLabels = (invoiceIds, fileType, withPrice, callback) => action(invoiceActionTypes.DOWNLOAD_SHIPPING_LABELS.REQUEST, {
    invoiceIds, fileType, withPrice, callback,
  })

  downloadShippingLabelsLoading = (downloadShippingLabelsLoading) => action(invoiceActionTypes.DOWNLOAD_SHIPPING_LABELS.LOADING, {
    downloadShippingLabelsLoading,
  });

  // Download Invoice List

  downloadInvoiceList = (payload, callback) => action(invoiceActionTypes.DOWNLOAD_INVOICE_LIST.REQUEST, {
    payload, callback,
  })

  downloadInvoiceListLoading = (downloadInvoiceListLoading) => action(invoiceActionTypes.DOWNLOAD_INVOICE_LIST.LOADING, {
    downloadInvoiceListLoading,
  });

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  createBulkReturns = (payload, callback) => action(invoiceActionTypes.CREATE_BULK_RETURNS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param createBulkReturnsLoading
   * @returns {{type: *}}
   */
  createBulkReturnsLoading = (createBulkReturnsLoading) => action(invoiceActionTypes.CREATE_BULK_RETURNS.LOADING, {
    createBulkReturnsLoading,
  })

  quickUpdateInvoice = (payload, callback, rollback) => action(invoiceActionTypes.QUICK_UPDATE_INVOICE.REQUEST, {
    payload, callback, rollback
  })

  quickUpdateInvoiceLoading = (quickUpdateInvoiceLoading) => action(invoiceActionTypes.QUICK_UPDATE_INVOICE.LOADING, {
    quickUpdateInvoiceLoading
  })

  // issue Stock for invoice
  issueStockForInvoice = (payload, callback) => action(invoiceActionTypes.ISSUE_STOCK_FOR_INVOICE.REQUEST, {
    payload, callback,
  })

  issueStockForInvoiceLoading = (issueStockForInvoiceLoading) => action(invoiceActionTypes.ISSUE_STOCK_FOR_INVOICE.LOADING, {
    issueStockForInvoiceLoading,
  })

  // revert Stock for invoice
  revertStockForInvoice = (payload, callback) => action(invoiceActionTypes.REVERT_STOCK_FOR_INVOICE.REQUEST, {
    payload, callback,
  })

  revertStockForInvoiceLoading = (revertStockForInvoiceLoading) => action(invoiceActionTypes.REVERT_STOCK_FOR_INVOICE.LOADING, {
    revertStockForInvoiceLoading,
  })
}

export default new InvoiceActions();
